<template>
      <div
        class="modal addnew-cusip"
        id="outstandingBid"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h3>There is an outstanding bid for the same cusip</h3>
              <p>Would you like to cancel the Outstanding Bid and place a new Bid?</p>
              <h4 class="cusip">{{selectedCusip.cusip}}</h4>
              <p>{{selectedCusip.description}}</p>
              <div class="bid-dtl">
                <div class="outstanding">
                  <div class="header">
                    <h4>Outstanding Bid</h4>
                    <h5 class="cursor-pointer" @click="openModal(outStandingBid.cognitoSub);"><i class="fas fa-user-circle"></i> {{outStandingBid.traderName}}</h5>
                  </div>
                  <div class="body">
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'" >Yield : <span>{{outStandingBid.amount}} %</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'" >TMC Price : <span>{{outStandingBid.tmcPrice}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'BIDPRICE'" >Bid Price : <span>{{outStandingBid.amount}}</span></div>
                    <div class="value">Par Value : <span>{{outStandingBid.quantity}}</span></div>
                    <div class="value">Minimum Quantity : <span>{{outStandingBid.minQuantity}}</span></div>
                    <div class="value"># Of Days : <span>{{outStandingBid.bidValidity}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Factor Ratio : 1 : <span>{{outStandingBid.factorRatio || 0}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Point To Date : <span>{{outStandingBid.pointToDate}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Point To Curve  : <span>{{outStandingBid.pointToCurve =='MUNICURVE' ? 'Muni Curve' : '10 year Treasury'}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Curve Yield : <span>{{outStandingBid.yield}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">Yield Spread : <span>{{outStandingBid.yieldSpread}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">BPS Range Min : <span>{{outStandingBid.minBps || 0}}</span></div>
                    <div class="value" v-if="outStandingBid.bidType == 'YIELD'">BPS Range Max : <span>{{outStandingBid.maxBps || 0}}</span></div>
                  </div>
                </div>
                <div class="newbid">
                  <div class="header">
                    <h4>New Bid</h4>
                  </div>
                  <div class="body">
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'" >Yield : <span>{{selectedCusip.amount}} %</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'" >TMC Price : <span>{{selectedCusip.tmcPrice}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'BIDPRICE'" >Bid Price : <span>{{selectedCusip.amount}}</span></div>
                    <div class="value">Par Value : <span>{{selectedCusip.quantity}}</span></div>
                    <div class="value">Minimum Quantity : <span>{{selectedCusip.minQuantity}}</span></div>
                    <div class="value"># Of Days : <span>{{selectedCusip.bidValidity}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Factor Ratio : 1 : <span>{{selectedCusip.factorRatio || 0}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Point To Date : <span>{{selectedCusip.pointToDate}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Point To Curve  : <span>{{selectedCusip.pointToCurve =='MUNICURVE' ? 'Muni Curve' : '10 year Treasury'}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Curve Yield : <span>{{selectedCusip.yield}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">Yield Spread : <span>{{selectedCusip.yieldSpread}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">BPS Range Min : <span>{{selectedCusip.minBps || 0}}</span></div>
                    <div class="value" v-if="selectedCusip.bidType == 'YIELD'">BPS Range Max : <span>{{selectedCusip.maxBps || 0}}</span></div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div v-if="bidLoading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div> -->

            <div class="modal-footer bid-dtl-ftr">
              <!-- <router-link to="/bidside/bidlist"  data-dismiss="modal" >Goto Outstanding Bids </router-link> -->
              <button type="button" @click="$emit('create')"  class="btn btn-danger">Cancel Outstanding Bid & Place New Bid</button>
            </div>
          </div>
        </div>
        <trader-info 
            v-bind:traderInfo="traderData" 
            v-if="traderData" 
            @close="traderData = null"
      ></trader-info>
      </div>
</template>
<script>
//import config from "@/config";
import config from "@/config";
import authService from "@/authService";
import TraderInfo from "../../admin/TraderInfoPopup"

export default {
  name: "OutstandingBidExistPopup",
   components: {
    TraderInfo
  },
  props: ['outStandingBid','selectedCusip'],
  data() {
    return {
        traderData : null
    };
  },
  methods: {
    openModal(cognitoSub) {
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user?cognitoSub="+
            cognitoSub,
            auth
        )
        .then(result => {
          this.traderData = result.data;
          
        })
        .catch(e => {
          console.log(e);
         

        });
    }, 
  },
  mounted() {
   
  }
};
</script>